import { TOKEN_KEY } from "../../constants/AppConstants";
import http from "../http";

export const updateAllNotifications = (body) => {
  return (dispatch) => {
    return http
      .put(`/notifications`, body)
      .then(() => {
        //message.success('Post updated Successfully');
        getAllNotifications()(dispatch);
        return true;
      })
      .catch((err) => {
        //message.error(err.response?.data.message[0]);
        console.error(err);
      });
  };
};

export const getAllNotifications = (size = 10, page = 1) => {
  return (dispatch, getState) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      http
        .get(`/notifications`)
        .then((res) => {
          const data = res.data.data;
          dispatch({
            type: "GET_NOTIFICATIONS",
            pageNo: page,
            count: data.count,
            notifications: data.notifications,
          });
        })
        .catch((err) => {
          //message.error(err.response?.data.message[0]);
          console.error(err);
        });
    }
  };
};
